import React, { useState } from 'react';
import { Alert, Row } from 'reactstrap';
import Pagination from 'rc-pagination';
import CustomTemplateRow from './CustomTemplateRow';
import SortIcons from '../components/ProposalsSortIcons';
import SetLimitEntries from '../components/SetLimitEntries';
import DeleteModal from '../components/DeleteModal';
import { ENG_LOCALE } from '../lib/constants';
import './CustomTemplate.css';

const CustomTemplateList = ({
  templates = [],
  onSort,
  sortValue,
  onView,
  onDelete,
  onSetLimit,
  onChangePagination,
  page = 1,
  totalDocs = 0,
  limit = 10,
  totalPages = 0,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleDeleteClick = template => {
    setSelectedTemplate(template);
    setDeleteModalOpen(true);
  };
  const handleDeleteCancel = () => {
    setSelectedTemplate(null);
    setDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    if (selectedTemplate && onDelete) {
      onDelete(selectedTemplate);
    }

    setSelectedTemplate(null);
    setDeleteModalOpen(false);
  };

  return (
    <>
      <div className="custom-template-list ">
        <div className="custom-template-table-wrapper">
          <table className="custom-template-table">
            <thead>
              <tr>
                <th className="cursor-pointer" onClick={() => onSort('companyBox.name')}>
                  Company Name <SortIcons sortObj={sortValue} sortName="companyBox.name" />
                </th>
                <th className="cursor-pointer" onClick={() => onSort('name')}>
                  Line Type <SortIcons sortObj={sortValue} sortName="name" />
                </th>
                <th className="cursor-pointer" onClick={() => onSort('title')}>
                  Template Name <SortIcons sortObj={sortValue} sortName="title" />
                </th>
                <th colSpan="1">Actions</th>
              </tr>
            </thead>
  
            <tbody>
              {templates && templates.length ? (
                templates.map(template => (
                  <CustomTemplateRow
                    key={template._id}
                    template={template}
                    onView={onView}
                    onDelete={() => handleDeleteClick(template)}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <Alert color="info">No Custom Templates Found</Alert>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
  
        {totalPages > 0 && (
          <div className="custom-template-pagination-footer">
            <Row className="justify-content-md-center align-items-center m-0">
              <SetLimitEntries onChange={onSetLimit} />
  
              <Pagination
                locale={ENG_LOCALE}
                className="pagination-container"
                onChange={onChangePagination}
                current={page}
                total={totalDocs}
                pageSize={limit}
                showLessItems
                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
              />
            </Row>
          </div>
        )}
      </div>
  
      <DeleteModal
        isOpen={deleteModalOpen}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        message={`Are you sure you want to delete ${
          selectedTemplate?.title || selectedTemplate?.name || 'this template'
        }?`}
      />
    </>
  );
};

export default CustomTemplateList;